import { Warning } from "@phosphor-icons/react";

export default function DisclaimerBanner() {
    return (
        <div className="bg-amber-50 border-t border-amber-200 text-amber-900" data-testid="disclaimer-banner">
            <div className="max-w-[1400px] mx-auto px-6 py-2.5 flex items-center gap-3 text-xs">
                <Warning size={14} weight="fill" className="text-amber-700 shrink-0" />
                <p>
                    <span className="font-semibold">LienLift Direct is a judgment information &amp; document service — not a law firm.</span>{" "}
                    We provide informational research, calculations and draft documents at your direction.{" "}
                    <span className="font-semibold">You sign, you send, you negotiate, you decide.</span> This is not legal advice.
                </p>
            </div>
        </div>
    );
}
